export const DISTANCE_CONVERSION_FACTORS = {
  METERS_PER_KILOMETER: 1000,
  METERS_PER_MILE: 1609.34,
  FEET_PER_METER: 3.28084,
  YARDS_PER_METER: 1.09361,
} as const;

export const AREA_CONVERSION_FACTORS = {
  SQUARE_METERS_PER_SQUARE_KILOMETER: 1_000_000,
  SQUARE_METERS_PER_HECTARE: 10_000,
  SQUARE_METERS_PER_ACRE: 4046.86,
  SQUARE_METERS_PER_SQUARE_MILE: 2_589_988,
  SQUARE_FEET_PER_SQUARE_METER: 10.7639,
} as const;
